import api from "../../../api/api";
import API_URL from "../../../api/url";
import axios from 'axios';

const webTestimonialRequest = {
  // categoryList: (page, limit) => api.get(`${API_URL.BASEURL}${API_URL.getCategory}?page=${page}&limit=${limit}`),
  getTestimonialList: (values) => api.get(`${API_URL.BASEURL}${API_URL.webGetTestimonial}`, {
    params: {
      search: values?.search
    }
  }),

  postDeleteTestimonial: (id) => api.delete(`${API_URL.BASEURL}${API_URL.webTestimonialDelete}?id=${id}`),
  postUpdaTetestimonial: (values) => api.post(`${API_URL.BASEURL}${API_URL.webUpdateTestimonial}`, values),
  gettesTimonialDetail: (id) => api.get(`${API_URL.BASEURL}${API_URL.webTestimonialDetails}?id=${id}`),
  createTestimonial: (values) => api.post(`${API_URL.BASEURL}${API_URL.webCreateTestimonial}`, values),
  
  uploadImage: (formData) => {
    const token = localStorage.getItem("accesstoken");


    return api.post(
      `${API_URL.BASEURL}${API_URL.uploadImg}?moduleName=photos`,
      formData,
      {
        headers: {
          token: token ? `${token}` : "",
        },
      }
    );
  }


};



export default webTestimonialRequest